import { Gear, Blinker, ControlMode, DriveMode, SelectorMode } from 'core/models/drive';

export enum GearCode {
    D = 1,
    R = 2,
    N = 4,
    P = 5,
}

export function fromGearCode(i: number): Gear {
    switch (i) {
        case GearCode.D:
            return Gear.D;
        case GearCode.R:
            return Gear.R;
        case GearCode.N:
            return Gear.N;
        case GearCode.P:
            return Gear.P;
        default:
            return Gear.D;
    }
}

export function toGearCode(i: Gear): GearCode {
    switch (i) {
        case Gear.D:
            return GearCode.D;
        case Gear.R:
            return GearCode.R;
        case Gear.N:
            return GearCode.N;
        case Gear.P:
            return GearCode.P;
        default:
            return GearCode.D;
    }
}

enum BlinkerCode {
    UNKNOWN = 0,
    LEFT = 1,
    RIGHT = 2,
    HAZARD = 3,
}

export function fromBlinkerCode(code: BlinkerCode): Blinker | undefined {
    switch (code) {
        case BlinkerCode.LEFT:
            return Blinker.Left;
        case BlinkerCode.RIGHT:
            return Blinker.Right;
        case BlinkerCode.HAZARD:
            return Blinker.Hazard;
    }
    return undefined;
}

export function toBlinkerCode(blinker: Blinker | null): BlinkerCode {
    if (blinker == null) {
        return BlinkerCode.UNKNOWN;
    }

    switch (blinker) {
        case Blinker.Hazard:
            return BlinkerCode.HAZARD;
        case Blinker.Left:
            return BlinkerCode.LEFT;
        case Blinker.Right:
            return BlinkerCode.RIGHT;
    }
}

enum ControlModeCode {
    CONTROL_MODE_UNKNOWN = 0,
    CONTROL_MODE_AUTO = 1,
    CONTROL_MODE_REMOTE = 2,
}

export function toControlModeCode(controlMode: ControlMode): ControlModeCode {
    switch (controlMode) {
        case ControlMode.Auto:
            return ControlModeCode.CONTROL_MODE_AUTO;
        case ControlMode.Remote:
            return ControlModeCode.CONTROL_MODE_REMOTE;
    }
}

enum RemoteModeCode {
    REMOTE_MODE_OFF = 0,
    REMOTE_MODE_ON = 1,
}

export function controlModeToRemoteModeCode(controlMode: ControlMode): RemoteModeCode {
    switch (controlMode) {
        case ControlMode.Auto:
            return RemoteModeCode.REMOTE_MODE_OFF;
        case ControlMode.Remote:
            return RemoteModeCode.REMOTE_MODE_ON;
    }
}

export function toDriveMode(mode: number) {
    switch (mode) {
        case 0: return DriveMode.Manual;
        case 1: return DriveMode.Auto;
        case 2: return DriveMode.Remote;
        default: return undefined;
    }
}

export function toSelectorMode(mode: number) {
    switch (mode) {
        case 0: return SelectorMode.Local;
        case 1: return SelectorMode.Remote;
        default: return undefined;
    }
}
